import React, { memo, useMemo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import Lottie from 'lottie-react'
import shieldAnimation from '../assets/animations/shield.json'
import { Settings } from 'src/components/settings/Settings'
import { useAuthTokens } from 'src/hooks/useAuthTokens'

interface Props {
  flow?: 'client' | 'contractorPortal'
}

const LoadingPageComponent = ({ flow }: Props) => {
  const { authToken: clientAuthToken, contractorPortalAuthToken } = useAuthTokens()

  const authToken = useMemo(() => {
    if (flow === 'client') {
      return clientAuthToken
    }

    if (flow === 'contractorPortal') {
      return contractorPortalAuthToken
    }

    return null
  }, [flow, clientAuthToken, contractorPortalAuthToken])

  return (
    <div css={tw`w-full h-full flex flex-1 flex-col`}>
      {authToken && (
        <div css={tw`bg-primary-700 w-full h-16 p-4 top-0 flex justify-end items-center`}>
          <div css={tw`flex-row flex gap-2`}>
            <Settings hideSwitchButtons flow={flow} />
          </div>
        </div>
      )}
      <div css={tw`w-full h-full flex flex-1 flex-col bg-primary-800 items-center justify-center`}>
        <Lottie animationData={shieldAnimation} loop={true} />
        <Typography css={tw`font-bold mt-4 [font-size: 12px] text-shades-0`}>LOADING...</Typography>
      </div>
    </div>
  )
}

export const LoadingPage = memo(LoadingPageComponent)
